<script>
import BulkImportCollectionRecords from '@/layerAdmin/components/BulkImportCollectionRecords.vue';
import BulkImportPackingRecords from '@/layerAdmin/components/BulkImportPackingRecords.vue';

export default {
  components: {
    BulkImportCollectionRecords,
    BulkImportPackingRecords,
  },
}
</script>

<template>
  <b-card no-body="">
    <b-tabs card>

      <b-tab title="Collection Records">
        <bulk-import-collection-records />
      </b-tab>

      <b-tab title="Packing Records">
        <bulk-import-packing-records />
      </b-tab>

    </b-tabs>
  </b-card>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/views/BulkImportView.vue